/**
 * Build customer login URL for a storefront shop, preserving return path after login.
 * Prefer `redirect` query so CustomerLogin returns to checkout (not only `state.from`).
 */
export function buildStorefrontCustomerLoginHref(opts: {
  slug: string
  /** Path to return to after login, e.g. `/shop/foo/checkout` */
  returnPath: string
}): string {
  const params = new URLSearchParams()
  params.set('shop', opts.slug)
  params.set('redirect', opts.returnPath)
  return `/auth/customer/login?${params.toString()}`
}
